'use client';

import SvgHamburger from '@common/icon/SvgHamburger';
import SvgMagnifyingGlass from '@common/icon/SvgMagnifyingGlass';
import SvgManual from '@common/icon/SvgManual';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { useState } from 'react';

import { CustomLink } from '@/app/_components/CustomLink';
import { ServiceShortcutFullScreenModal } from '@/app/(allowed)/my/_components/ServiceShortcutMenu';
import { PageNavigation } from '@/components/client';
import { DONATION_ROUTES, ROUTES } from '@/constants';
import { useCheckKakaobank } from '@/hooks/useCheckKakaobank';
import { gtmDatasets } from '@/utils/analytics/gtm';

const ICON_BUTTON_CLASS_NAME = cn(
  'grid size-44 place-items-center rounded-pill transition-colors duration-150',
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500',
  'hover:bg-Gray-50 active:bg-Gray-100',
);

export const DonationHomeNavigation = ({
  className,
}: {
  className?: string;
}) => {
  const isKakaobank = useCheckKakaobank();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  //* 메인홈 주소로 rewrite된 진입은 메인홈처럼 앱 뒤로가기에 종료 모달을 띄운다
  const isRootEntry = usePathname() === ROUTES.HOME.pathname;
  const searchHref = isKakaobank
    ? DONATION_ROUTES.SEARCH.pathname
    : ROUTES.SEARCH.withSearchParams({
        searchParams: { category: 'gifts' },
      });

  return (
    <PageNavigation
      className={className}
      isNotUsedHomeButton
      logo="symbol"
      logoHref={
        isRootEntry ? ROUTES.HOME.pathname : DONATION_ROUTES.HOME.pathname
      }
      backButton={false}
      enableHistoryBack={!isRootEntry}
    >
      {/* 시안은 44 히트 영역 3개를 간격 없이 붙이고 오른쪽 여백 10 — 공용 검색 버튼(26)과 섞으면 간격이 들쭉날쭉해 직접 그린다 */}
      <div className="-mr-10 flex items-center">
        <CustomLink
          href={searchHref}
          aria-label="검색으로 이동"
          className={ICON_BUTTON_CLASS_NAME}
          {...gtmDatasets.clickGnb({ menu_name: '검색' })}
        >
          <SvgMagnifyingGlass className="size-24" />
        </CustomLink>
        <CustomLink
          href={DONATION_ROUTES.GUIDE.pathname}
          aria-label="고향사랑기부혜택"
          className={ICON_BUTTON_CLASS_NAME}
          {...gtmDatasets.clickGnb({ menu_name: '고향사랑기부혜택' })}
        >
          <SvgManual className="size-24" />
        </CustomLink>
        {/* 연말 이벤트 한정(WEL-5478) — 웰로 홈과 같은 바로가기 메뉴. 채널별 숨김은 메뉴 내용이 처리한다 */}
        <button
          type="button"
          aria-label="전체 메뉴"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen(true)}
          className={ICON_BUTTON_CLASS_NAME}
        >
          <SvgHamburger className="size-24" />
        </button>
      </div>
      <ServiceShortcutFullScreenModal
        open={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
      />
    </PageNavigation>
  );
};
